import type { Moneda } from '@/shared/billing/currency';
import { TenantId } from '../value-objects/TenantId';

export class PanelPago {
  private constructor(
    public readonly id: number,
    public readonly clinicaId: TenantId,
    public readonly nombreClinica: string,
    public readonly fechaPago: Date | null,
    public readonly fechaPeriodoPago: string,
    public readonly monto: number,
    public readonly planId: string | null,
    public readonly medioPago: number | null,
    public readonly medioPagoDescripcion: string | undefined,
    public readonly usuarioRegistroId: number | null,
    public readonly nombreArchivoComprobante: string | null,
    public readonly notas: string | null,
    public readonly estadoPagoId: number,
    public readonly estadoPagoDescripcion: string,
    public readonly deudaAcumulada: number,
    public readonly tenantId: string | null = null,
    public readonly emailAdministrador: string | null = null,
    public readonly telefonoContacto: string | null = null,
    public readonly nombreDueno: string | null = null,
    /** Moneda de la factura y del cobro. */
    public readonly moneda: Moneda = 'ARS'
  ) {}

  static create(
    id: number,
    clinicaId: number | string,
    nombreClinica: string,
    fechaPago: Date | null,
    fechaPeriodoPago: string,
    monto: number,
    planId: string | null,
    medioPago: number | null,
    estadoPagoId: number,
    estadoPagoDescripcion: string,
    deudaAcumulada: number,
    medioPagoDescripcion?: string,
    usuarioRegistroId?: number,
    nombreArchivoComprobante?: string,
    notas?: string,
    tenantId?: string | null,
    emailAdministrador?: string | null,
    telefonoContacto?: string | null,
    nombreDueno?: string | null,
    moneda?: Moneda
  ): PanelPago {
    // Preferir GUID de tenant; evitar clinicaId 0/null (histórico INT) que rompe TenantId.create(0)
    const hasNumericClinica =
      typeof clinicaId === 'number' && Number.isFinite(clinicaId) && clinicaId > 0;
    const hasStringClinica =
      typeof clinicaId === 'string' && clinicaId.trim() !== '' && clinicaId !== '0';
    const hasTenant =
      typeof tenantId === 'string' ? tenantId.trim() !== '' : tenantId != null && tenantId !== '';

    const resolvedId = hasStringClinica
      ? (clinicaId as string).trim()
      : hasTenant
        ? (typeof tenantId === 'string' ? tenantId.trim() : tenantId!)
        : hasNumericClinica
          ? (clinicaId as number)
          : null;

    if (resolvedId == null) {
      throw new Error('PanelPago requiere tenantId (GUID) o clinicaId válido');
    }

    return new PanelPago(
      id,
      TenantId.create(resolvedId),
      nombreClinica,
      fechaPago,
      fechaPeriodoPago,
      monto,
      planId,
      medioPago,
      medioPagoDescripcion,
      usuarioRegistroId || null,
      nombreArchivoComprobante || null,
      notas || null,
      estadoPagoId,
      estadoPagoDescripcion,
      deudaAcumulada,
      tenantId ?? (typeof clinicaId === 'string' ? clinicaId : null),
      emailAdministrador ?? null,
      telefonoContacto ?? null,
      nombreDueno ?? null,
      moneda ?? 'ARS'
    );
  }
}
